module.exports = __webpack_public_path__ + "img/certificate-3.035f538b.png";